import React  from 'react';

export const BuyBilet = (props) => {
    return <span className="price_bilet"> 
                <img src={props.img} alt="none"/>
                <p>Купить билет</p>
            </span>
}

